<template>
  <div class="container-fluid mt-4 SlimTDs">
    <b-row>
      <b-col>
        <span :class="`size-${ButtonSize}`">Ödeme Türleri</span>
      </b-col>

      <b-col class="text-right mb-3 top-buttons">
        <b-btn class="m-1" type="button" variant="danger" to="/Settings" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1" v-if="ScreenWidth >= 440">Ayarlar</span>
        </b-btn>

        <b-btn to="/Settings/PaymentTypes/Add" class="btn-info m-1" :size="ButtonSize">
          <i class="material-icons mifix">add</i>
          <span class="ml-1">
            <span v-if="ScreenWidth >= 320 && ScreenWidth < 340">Tür</span>
            <span v-if="ScreenWidth >= 340">Ödeme</span>
            <span class="ml-1" v-if="ScreenWidth >= 380">Türü</span>
            <span class="ml-1" v-if="ScreenWidth >= 410">Ekle</span>
          </span>
        </b-btn>
      </b-col>
    </b-row>

    <b-table
      striped
      hover
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items="PaymentTypes"
      :fields="fields"
      responsive
    >
      <template v-slot:cell(Name)="data">
        <div class="ws-nowrap">{{ data.item.Name }}</div>
      </template>

      <template v-slot:cell(Actions)="data">
        <b-btn size="sm" :to="`/Settings/PaymentTypes/${data.item.ID}`" class="mr-2">Düzenle</b-btn>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      sortBy: "Sort",
      sortDesc: false,
      fields: [
        { key: "Name", label: "Ödeme Türü Adı", sortable: true },
        { key: "Sort", label: "Sıralama", sortable: true },
        { key: "Actions", label: "İşlem", sortable: false }
      ]
    };
  },
  computed: {
    ...mapState(["StoreData", "ScreenWidth", "ButtonSize"]),
    PaymentTypes() {
      let _PaymentTypes = [];

      if (this.StoreData.PaymentTypes)
        for (let i in this.StoreData.PaymentTypes) {
          const _PaymentType = this.StoreData.PaymentTypes[i];

          _PaymentTypes.push({
            ID: _PaymentType.ID,
            Name: _PaymentType.Name,
            Sort: _PaymentType.Sort
          });
        }

      return _PaymentTypes;
    }
  },
  mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
